import { all, AllEffect, ForkEffect, put, retry, takeEvery } from 'redux-saga/effects';
import { getLimitsError, getLimitsSuccess, LimitsActionType } from '../actions/limitsActions';
import { LimitDuration, LimitType } from '@lucky7ventures/lucky-components';
import { envIsSweden } from '@/constants/constants';
import BffApiService from '@/shared/bffApiService';
import { SagaIterator } from 'redux-saga';
import { BffUserLimitsResponse } from '@lucky7ventures/bff-types';

/*
 Due to business logic for the Sweden flow where GiG sets the initial deposit
 limits upon user registration to the maximum values - so it can count the first
 deposit towards the limit we want to filter out those default set limits from the Frontend and
 consider them not-set.
 */
const filterLimits = (limits: BffUserLimitsResponse): BffUserLimitsResponse => {
  if (!envIsSweden()) {
    // if environment is not SWEDEN we want to keep the limits as-is
    return limits;
  }

  return {
    activeLimits: limits.activeLimits.filter(limit => {
      if (limit.limitType !== LimitType.Deposit) {
        // we want to keep all the limits that are not of type Deposit
        return true;
      }
      if (limit.duration === LimitDuration._24Hours && limit.amount === 500001) {
        return false;
      }
      if (limit.duration === LimitDuration._1Week && limit.amount === 1000000) {
        return false;
      }
      if (limit.duration === LimitDuration._1Month && limit.amount === 1000000) {
        return false;
      }
      return true;
    }),
    futureLimits: limits.futureLimits,
  };
};

export function* getLimitsSaga(): SagaIterator {
  try {
    const response = yield retry(3, 3000, BffApiService.getUserLimits);
    yield put(getLimitsSuccess(filterLimits(response.data.data)));
  } catch (error) {
    yield put(getLimitsError());
  }
}

export function* watchLimits(): Generator<AllEffect<ForkEffect<never>>, void> {
  yield all([takeEvery(LimitsActionType.GetLimits, getLimitsSaga)]);
}
